var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:['ltk-img', 'grey-10', _vm.rounded && 'rounded'],style:(`padding-bottom: ${_vm.aspectRatio * 100}%`)},[_c('c-image',_vm._b({},'c-image',_vm.imageAttrs,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }